// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Link } from 'react-router-dom';

// import {
//     faFacebook,
//     faLinkedin,
//     faInstagram,
//     faYoutube,
//     faTwitter,
// } from "@fortawesome/free-brands-svg-icons";
// import logo from "../Component/maamaaslog.png" // ✅ import your logo image

// const Footer = () => {
//     const [showLanguageModal, setShowLanguageModal] = useState(false);

//     // Open Language Modal
//     const handleLanguageClick = () => {
//         setShowLanguageModal(true);
//     };

//     // Close Language Modal
//     const handleCloseModal = () => {
//         setShowLanguageModal(false);
//     };

//     return (
//         <footer style={styles.footer}>
//             <div className="container-fluid">
               
                    
//                 <hr style={styles.line} />

//                 <div className="ffft" style={styles.subfooter}>
//                     {/* Logo */}
//                     <div className="" style={styles.logoTextContainer}>
//                         <div style={styles.logoContainer}>
                         
//                         </div>

//                         <p style={styles.logoText}></p>
//                     </div>



//                     {/* Center Text */}
//                     <div style={styles.subfooterText}>
//                         <p>
//                             Copyright © 2025, All Rights Reserved To <strong>MAAMAAS</strong> {" "}
//                             <strong></strong>

//                             <a href="/Termscondition" style={{ color: "orange" }}>
//                                 Terms of Use | Privacy Environmental Policy
//                             </a>
//                         </p>
//                     </div>

                    
//                 </div>

               

//             </div>
//         </footer>
//     );
// };

// const styles = {

//     footer: {
//         // backgroundColor: '#39164c',
//         color: '#fff',
//         // padding: '20px 0',
//         fontSize: '16px',
//         fontFamily: "Roboto",
//         fontWeight: '300',

//     },
//     socialIcons: {
//         display: 'flex',
//         justifyContent: 'flex-start',
//         marginBottom: '10px',
//     },
//     icon: {
//         fontSize: '20px',
//         color: '#fff',
//         margin: '0 10px',
//         cursor: 'pointer',
//     },
//     row: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         flexWrap: 'wrap',
//         marginBottom: '20px',
//     },
//     column: {
//         flex: '1',
//         // margin: ' 5px',
//         minWidth: '200px',
//     },
//     heading: {
//         fontSize: '18px',
//         fontWeight: '400',
//         marginBottom: '10px',
//         color: 'orange',
//     },
//     // line: {
//     //     border: 'none',
//     //     borderBottom: '1px solid orange',
//     //     marginBottom: '0px',
//     // },
//     list: {
//         listStyle: 'none',
//         padding: 0,
//         borderBottom: 'none',
//     },
//     listItem: {
//         marginBottom: '5px',
//     },
//     subfooter: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: 'black',
//          borderRadius:"5px",
//         // padding: '10px 20px',
//         color: 'white',
//     },
//     logoContainer: {
//         flex: 1,
//         textAlign: 'left',
//     },
//     logo: {
//         height: '40px', // Adjust the height as needed
//     },
//     logoTextContainer: {
//         display: 'flex',
//         alignItems: 'center',
//         textAlign: 'left',
//     },
//     subfooterText: {
//         flex: 2,
//         textAlign: 'center',
//         fontFamily: 'sans,serif',

//     },
//     languageContainer: {
//         // flex: 1,
//         textAlign: 'right',
//     },
//     languageButton: {
//         background: 'transparent',
//         border: 'none',
//         color: '#fff',
//         cursor: 'pointer',
//         fontSize: '30px',
//         marginRight: '20px',
//     },
// };

// const modalStyles = {
//     overlay: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 1000,
//     },
//     modal: {
//         backgroundColor: "#fff",
//         borderRadius: "8px",
//         padding: "20px",
//         width: "300px",
//         textAlign: "center",
//     },
//     title: {
//         fontSize: "20px",
//         marginBottom: "15px",
//     },
//     languageList: {
//         listStyle: "none",
//         padding: 0,
//         margin: "10px 0",
//     },
//     languageItem: {
//         margin: "5px 0",
//         padding: "3px 10px",
//         cursor: "pointer",
//         borderRadius: "4px",
//         backgroundColor: "#313840",
//         textAlign: "center",
//     },
//     closeButton: {
//         marginTop: "20px",
//         padding: "10px 20px",
//         backgroundColor: "#007BFF",
//         color: "#fff",
//         border: "none",
//         cursor: "pointer",
//         borderRadius: "4px",
//     },
// };

// export default Footer;




// import React, { useState, useRef, useEffect } from "react";
// import appstore from "./Cloudimages/appstore.png";
// import playstore from "./Cloudimages/google.png";
// // import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";

// const FooterMaamaas = () => {
//   const [openChat, setOpenChat] = useState(false);
//   const [chatInput, setChatInput] = useState("");
//   const [messages, setMessages] = useState([]);
//   const chatEndRef = useRef(null);

//   const sendMessage = () => {
//     if (!chatInput.trim()) return;

//     const newMessage = {
//       text: chatInput,
//       sender: "user",
//       time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//     };

//     setMessages((prev) => [...prev, newMessage]);
//     setChatInput("");

//     setTimeout(() => {
//       const reply = {
//         text: "Thank you for contacting Maamaas! Our support team will get back to you shortly 😊",
//         sender: "bot",
//         time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//       };
//       setMessages((prev) => [...prev, reply]);
//     }, 800);
//   };

//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   return (
//     <div style={{ width: "100%", background: "#f5f5f7", marginTop: "50px", padding: "40px 0", position: "relative" }}>
//       <div style={{ width: "90%", height: "1px", background: "#d3d3d3", margin: "0 auto 25px auto" }} />

//       {/* <div style={styles.footerContainer}>
//         <h2 style={styles.footerText}>
//           For better experience, download the Maamaas app now
//         </h2>

//         <div style={styles.storeContainer}>
//           <img
//             src={appstore}
//             alt="App Store"
//             style={styles.storeImg}
//             onClick={() => window.open("https://www.apple.com/in/app-store/", "_blank")}
//           />
//           <img
//             src={playstore}
//             alt="Google Play"
//             style={styles.storeImg}
//             onClick={() => window.open("https://play.google.com/store/apps/details?id=com.maamaas.app", "_blank")}
//           />
//         </div>
//       </div> */}

//       <p style={styles.bottomText}>
//         @ 2025  • info@maamaas.com • All Rights Reserved In Envision Integrated Services Pvt. Ltd.
//       </p>

//       <button style={styles.chatButton} onClick={() => setOpenChat(!openChat)}>
//        Let’s Connect
//       </button>

//       {openChat && (
//         <div style={styles.chatBox}>
//           <div style={styles.chatHeader}>
//             <span>Maamaas Live Support</span>
//             <span style={{ cursor: "pointer" }} onClick={() => setOpenChat(false)}>✖</span>
//           </div>

//           <div style={styles.chatBody}>
//             {messages.map((msg, index) => (
//               <div
//                 key={index}
//                 style={{
//                   ...styles.message,
//                   alignSelf: msg.sender === "user" ? "flex-end" : "flex-start",
//                   background: msg.sender === "user" ? "#ee6521" : "#e8e8e8",
//                   color: msg.sender === "user" ? "#fff" : "#333",
//                 }}
//               >
//                 <div>{msg.text}</div>
//                 <div style={styles.time}>{msg.time}</div>
//               </div>
//             ))}
//             <div ref={chatEndRef} />
//           </div>

//           <div style={styles.chatInputWrapper}>
//             <input
//               type="text"
//               placeholder="Type your message…"
//               style={styles.chatInput}
//               value={chatInput}
//               onChange={(e) => setChatInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && sendMessage()}
//             />
//             <button style={styles.sendBtn} onClick={sendMessage}>Send</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // -------- Internal CSS --------
// const styles = {
//   footerContainer: {
//     width: "90%",
//     margin: "auto",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "20px",
//   },
//   footerText: {
//     fontSize: "22px",
//     fontWeight: "600",
//     color: "#444",
//     textAlign: "center",
//   },
//   storeContainer: {
//     display: "flex",
//     gap: "15px",
//     flexWrap: "wrap",
//     justifyContent: "center",
//   },
//   storeImg: {
//     width: "160px",
//     cursor: "pointer",
//     transition: "transform .2s",
//   },
//   bottomText: {
//     textAlign: "center",
//     marginTop: "25px",
//     fontSize: "15px",
//     color: "#555",
//   },
//   chatButton: {
//     position: "fixed",
//     bottom: "25px",
//     right: "25px",
//     background: "#ee6521",
//     color: "#fff",
//     fontSize: "17px",
//     zIndex: 1000,
//     fontWeight: "600",
//     padding: "14px 22px",
//     border: "none",
//     borderRadius: "30px",
//     cursor: "pointer",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
//   },
//   chatBox: {
//   position: "fixed",
//   bottom: "90px",
//   right: "25px",
//   width: "360px",
//   height: "460px",
//   background: "#ffffff",
//   borderRadius: "14px",
//   zIndex: 1000,
//   boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
//   display: "flex",
//   flexDirection: "column",
//   overflow: "hidden",

//   // 👉 Responsive
//   "@media (max-width: 900px)": {
//     width: "80vw",
//     height: "70vh",
//     bottom: "40px",
//     right: "10px",
//     borderRadius: "12px",
//   },
//   "@media (max-width: 600px)": {
//     width: "100vw",
//     height: "100vh",
//     bottom: "0",
//     right: "0",
//     left: "0",
//     borderRadius: "0",
//   },
// },
// chatHeader: {
//   background: "#ee6521",
//   color: "#fff",
//   padding: "14px",
//   fontSize: "18px",
//   fontWeight: "600",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",

//   "@media (max-width: 600px)": {
//     fontSize: "20px",
//     padding: "18px",
//   },
// },
// chatBody: {
//   flex: 1,
//   padding: "12px",
//   display: "flex",
//   flexDirection: "column",
//   gap: "12px",
//   overflowY: "auto",

//   "@media (max-width: 600px)": {
//     padding: "16px",
//   },
// },
// message: {
//   maxWidth: "75%",
//   padding: "10px 12px",
//   borderRadius: "10px",
//   fontSize: "15px",
//   lineHeight: "20px",
//   wordBreak: "break-word",

//   "@media (max-width: 600px)": {
//     fontSize: "16px",
//   },
// },
// time: {
//   fontSize: "11px",
//   textAlign: "right",
//   marginTop: "4px",
//   opacity: 0.7,
// },
// chatInputWrapper: {
//   display: "flex",
//   borderTop: "1px solid #ddd",

//   "@media (max-width: 600px)": {
//     borderTop: "2px solid #ddd",
//   },
// },
// chatInput: {
//   flex: 1,
//   border: "none",
//   padding: "11px",
//   fontSize: "15px",
//   outline: "none",

//   "@media (max-width: 600px)": {
//     padding: "16px",
//     fontSize: "17px",
//   },
// },
// sendBtn: {
//   background: "#ee6521",
//   color: "#fff",
//   border: "none",
//   padding: "12px 18px",
//   cursor: "pointer",
//   fontWeight: "600",
//   fontSize: "15px",

//   "@media (max-width: 600px)": {
//     padding: "18px 22px",
//     fontSize: "17px",
//   },
// },

// };

// export default FooterMaamaas;




// import React, { useState, useRef, useEffect } from "react";
// import appstore from "./Cloudimages/appstore.png";
// import playstore from "./Cloudimages/google.png";

// const FooterMaamaas = () => {
//   const [openChat, setOpenChat] = useState(false);
//   const [chatInput, setChatInput] = useState("");
//   const [messages, setMessages] = useState([
//     {
//       text: "Hello! 👋 How can we help you today?",
//       sender: "bot",
//       time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//     }
//   ]);
//   const chatEndRef = useRef(null);

//   const sendMessage = () => {
//     if (!chatInput.trim()) return;

//     const newMessage = {
//       text: chatInput,
//       sender: "user",
//       time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//     };

//     setMessages((prev) => [...prev, newMessage]);
//     setChatInput("");

//     setTimeout(() => {
//       const replies = [
//         "Thank you for contacting Maamaas! Our support team will get back to you shortly 😊",
//         "We've received your message. One of our representatives will assist you soon.",
//         "Thanks for reaching out! We typically respond within 1-2 business hours.",
//         "Your inquiry is important to us. We'll connect you with the right team member."
//       ];
//       const reply = {
//         text: replies[Math.floor(Math.random() * replies.length)],
//         sender: "bot",
//         time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//       };
//       setMessages((prev) => [...prev, reply]);
//     }, 800);
//   };

//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   return (
//     <div style={{ width: "100%", background: "#f5f5f7", marginTop: "50px", padding: "40px 0", position: "relative" }}>
//       {/* Top Divider */}
//       <div style={{ width: "90%", height: "1px", background: "linear-gradient(90deg, transparent, #d3d3d3, transparent)", margin: "0 auto 30px auto" }} />

//       {/* App Download Section */}
//       <div style={styles.footerContainer}>
//         <h2 style={styles.footerText}>
//           For the best experience, download the Maamaas app now
//         </h2>

//         <div style={styles.storeContainer}>
//           <div 
//             style={styles.storeButton}
//             onClick={() => window.open("https://www.apple.com/in/app-store/", "_blank")}
//           >
//             <img
//               src={appstore}
//               alt="App Store"
//               style={styles.storeImg}
//             />
//             <div style={styles.storeText}>
//               <div style={styles.storeSmallText}>Download on the</div>
//               <div style={styles.storeLargeText}>App Store</div>
//             </div>
//           </div>
          
//           <div 
//             style={styles.storeButton}
//             onClick={() => window.open("https://play.google.com/store/apps/details?id=com.maamaas.app", "_blank")}
//           >
//             <img
//               src={playstore}
//               alt="Google Play"
//               style={styles.storeImg}
//             />
//             <div style={styles.storeText}>
//               <div style={styles.storeSmallText}>Get it on</div>
//               <div style={styles.storeLargeText}>Google Play</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Copyright */}
//       <p style={styles.bottomText}>
//         © 2025 Maamaas • info@maamaas.com • All Rights Reserved by Envision Integrated Services Pvt. Ltd.
//       </p>

//       {/* Chat Button */}
//       <button 
//         style={{
//           ...styles.chatButton,
//           background: openChat ? "#8a4cb2" : "#ee6521",
//           transform: openChat ? "scale(0.95)" : "scale(1)"
//         }} 
//         onClick={() => setOpenChat(!openChat)}
//       >
//         <span style={styles.chatButtonText}>
//           {openChat ? "Close Chat" : "Let's Connect"}
//         </span>
//         <span style={styles.chatIcon}>{openChat ? "✕" : "💬"}</span>
//       </button>

//       {/* Chat Box */}
//       {openChat && (
//         <div style={styles.chatBox}>
//           <div style={styles.chatHeader}>
//             <div style={styles.chatHeaderLeft}>
//               <div style={styles.chatAvatar}>M</div>
//               <div>
//                 <div style={styles.chatTitle}>Maamaas Support</div>
//                 <div style={styles.chatStatus}>
//                   <span style={styles.statusDot}></span>
//                   Online • Usually replies in 5 mins
//                 </div>
//               </div>
//             </div>
//             <div style={styles.chatActions}>
//               <button style={styles.chatActionButton}>⋯</button>
//               <button 
//                 style={styles.chatActionButton}
//                 onClick={() => setOpenChat(false)}
//               >✕</button>
//             </div>
//           </div>

//           {/* Chat Messages Area */}
//           <div style={styles.chatBody}>
//             <div style={styles.welcomeMessage}>
//               Welcome to Maamaas Support! How can we assist you today?
//             </div>
            
//             {messages.map((msg, index) => (
//               <div
//                 key={index}
//                 style={{
//                   ...styles.messageWrapper,
//                   justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
//                 }}
//               >
//                 {msg.sender === "bot" && (
//                   <div style={styles.botAvatar}>M</div>
//                 )}
//                 <div
//                   style={{
//                     ...styles.message,
//                     background: msg.sender === "user" ? "linear-gradient(135deg, #ee6521, #8a4cb2)" : "#ffffff",
//                     color: msg.sender === "user" ? "#fff" : "#333",
//                     border: msg.sender === "bot" ? "1px solid #e8e8e8" : "none",
//                     boxShadow: msg.sender === "bot" ? "0 2px 8px rgba(0,0,0,0.05)" : "0 2px 8px rgba(177, 92, 214, 0.2)",
//                   }}
//                 >
//                   <div style={styles.messageText}>{msg.text}</div>
//                   <div style={styles.messageTime}>
//                     {msg.time} {msg.sender === "user" && "✓✓"}
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <div ref={chatEndRef} />
//           </div>

//           {/* Chat Input */}
//           <div style={styles.chatInputWrapper}>
//             <div style={styles.inputContainer}>
//               <input
//                 type="text"
//                 placeholder="Type your message here..."
//                 style={styles.chatInput}
//                 value={chatInput}
//                 onChange={(e) => setChatInput(e.target.value)}
//                 onKeyDown={(e) => e.key === "Enter" && sendMessage()}
//               />
//               <div style={styles.inputActions}>
//                 <button style={styles.attachButton}>📎</button>
//                 <button 
//                   style={{
//                     ...styles.sendBtn,
//                     opacity: chatInput.trim() ? 1 : 0.5,
//                     cursor: chatInput.trim() ? "pointer" : "not-allowed"
//                   }} 
//                   onClick={sendMessage}
//                   disabled={!chatInput.trim()}
//                 >
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <line x1="22" y1="2" x2="11" y2="13"></line>
//                     <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
//                   </svg>
//                 </button>
//               </div>
//             </div>
//             <div style={styles.chatFooter}>
//               <span style={styles.chatHint}>
//                 Press Enter to send • Support available 9 AM - 6 PM
//               </span>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // -------- Styles --------
// const styles = {
//   footerContainer: {
//     width: "90%",
//     maxWidth: "1200px",
//     margin: "0 auto 40px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "25px",
//   },
//   footerText: {
//     fontSize: "clamp(20px, 2.5vw, 28px)",
//     fontWeight: "700",
//     color: "#333",
//     textAlign: "center",
//     lineHeight: "1.4",
//     margin: "0",
//     background: "linear-gradient(135deg, #333 0%, #666 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//   },
//   storeContainer: {
//     display: "flex",
//     gap: "20px",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   storeButton: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     background: "#fff",
//     padding: "12px 24px",
//     borderRadius: "12px",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     border: "1px solid #e8e8e8",
//     minWidth: "200px",
//     ":hover": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
//     },
//     ":active": {
//       transform: "translateY(0)",
//     },
//   },
//   storeImg: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "8px",
//   },
//   storeText: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   storeSmallText: {
//     fontSize: "12px",
//     color: "#666",
//     lineHeight: "1.2",
//   },
//   storeLargeText: {
//     fontSize: "18px",
//     fontWeight: "600",
//     color: "#333",
//     lineHeight: "1.2",
//   },
//   bottomText: {
//     textAlign: "center",
//     marginTop: "30px",
//     fontSize: "clamp(13px, 2vw, 15px)",
//     color: "#666",
//     padding: "0 20px",
//     lineHeight: "1.6",
//   },
//   chatButton: {
//     position: "fixed",
//     bottom: "25px",
//     right: "25px",
//     background: "linear-gradient(135deg, #ee6521 0%, #8a4cb2 100%)",
//     color: "#fff",
//     fontSize: "16px",
//     zIndex: "1000",
//     fontWeight: "600",
//     padding: "16px 28px",
//     border: "none",
//     borderRadius: "50px",
//     cursor: "pointer",
//     boxShadow: "0 6px 20px rgba(177, 92, 214, 0.4)",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     transition: "all 0.3s ease",
//     ":hover": {
//       boxShadow: "0 8px 25px rgba(177, 92, 214, 0.5)",
//       transform: "translateY(-2px)",
//     },
//     "@media (max-width: 768px)": {
//       bottom: "20px",
//       right: "20px",
//       padding: "14px 22px",
//       fontSize: "15px",
//     },
//     "@media (max-width: 480px)": {
//       bottom: "15px",
//       right: "15px",
//       padding: "12px 20px",
//       fontSize: "14px",
//     },
//   },
//   chatButtonText: {
//     whiteSpace: "nowrap",
//   },
//   chatIcon: {
//     fontSize: "18px",
//   },
//   chatBox: {
//     position: "fixed",
//     bottom: "90px",
//     right: "25px",
//     width: "380px",
//     height: "500px",
//     background: "#ffffff",
//     borderRadius: "16px",
//     zIndex: "1000",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//     display: "flex",
//     flexDirection: "column",
//     overflow: "hidden",
//     border: "1px solid #e8e8e8",
//     animation: "fadeInUp 0.3s ease",
//     "@media (max-width: 768px)": {
//       width: "calc(100vw - 40px)",
//       height: "65vh",
//       bottom: "80px",
//       right: "20px",
//       left: "20px",
//       margin: "0 auto",
//     },
//     "@media (max-width: 480px)": {
//       width: "100vw",
//       height: "85vh",
//       bottom: "0",
//       right: "0",
//       left: "0",
//       borderRadius: "0",
//       border: "none",
//     },
//   },
//   chatHeader: {
//     background: "linear-gradient(135deg, #ee6521 0%, #8a4cb2 100%)",
//     color: "#fff",
//     padding: "18px 20px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   chatHeaderLeft: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//   },
//   chatAvatar: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.2)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "600",
//     fontSize: "18px",
//   },
//   chatTitle: {
//     fontSize: "16px",
//     fontWeight: "600",
//   },
//   chatStatus: {
//     fontSize: "12px",
//     opacity: "0.9",
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//   },
//   statusDot: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     background: "#4cd964",
//   },
//   chatActions: {
//     display: "flex",
//     gap: "8px",
//   },
//   chatActionButton: {
//     background: "transparent",
//     border: "none",
//     color: "#fff",
//     fontSize: "18px",
//     cursor: "pointer",
//     padding: "4px 8px",
//     borderRadius: "6px",
//     ":hover": {
//       background: "rgba(255,255,255,0.1)",
//     },
//   },
//   chatBody: {
//     flex: "1",
//     padding: "20px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//     overflowY: "auto",
//     background: "#f9f9fb",
//   },
//   welcomeMessage: {
//     background: "#fff",
//     padding: "12px 16px",
//     borderRadius: "12px",
//     fontSize: "14px",
//     color: "#666",
//     textAlign: "center",
//     margin: "0 auto",
//     border: "1px solid #e8e8e8",
//     maxWidth: "90%",
//   },
//   messageWrapper: {
//     display: "flex",
//     alignItems: "flex-end",
//     gap: "8px",
//   },
//   botAvatar: {
//     width: "32px",
//     height: "32px",
//     borderRadius: "50%",
//     background: "linear-gradient(135deg, #ee6521 0%, #8a4cb2 100%)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#fff",
//     fontWeight: "600",
//     fontSize: "14px",
//     flexShrink: "0",
//   },
//   message: {
//     maxWidth: "75%",
//     padding: "12px 16px",
//     borderRadius: "16px",
//     fontSize: "15px",
//     lineHeight: "1.5",
//     wordBreak: "break-word",
//   },
//   messageText: {
//     marginBottom: "4px",
//   },
//   messageTime: {
//     fontSize: "11px",
//     textAlign: "right",
//     opacity: "0.7",
//     marginTop: "4px",
//   },
//   chatInputWrapper: {
//     borderTop: "1px solid #e8e8e8",
//     background: "#fff",
//   },
//   inputContainer: {
//     display: "flex",
//     alignItems: "center",
//     padding: "12px 16px",
//     gap: "12px",
//   },
//   chatInput: {
//     flex: "1",
//     border: "none",
//     padding: "12px 16px",
//     fontSize: "15px",
//     outline: "none",
//     background: "#f9f9fb",
//     borderRadius: "12px",
//     "::placeholder": {
//       color: "#999",
//     },
//   },
//   inputActions: {
//     display: "flex",
//     gap: "8px",
//     alignItems: "center",
//   },
//   attachButton: {
//     background: "transparent",
//     border: "none",
//     fontSize: "20px",
//     cursor: "pointer",
//     padding: "8px",
//     borderRadius: "8px",
//     color: "#666",
//     ":hover": {
//       background: "#f9f9fb",
//     },
//   },
//   sendBtn: {
//     background: "linear-gradient(135deg, #ee6521 0%, #8a4cb2 100%)",
//     color: "#fff",
//     border: "none",
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: "all 0.3s ease",
//     ":hover": {
//       transform: "scale(1.05)",
//     },
//   },
//   chatFooter: {
//     padding: "8px 16px 12px",
//     borderTop: "1px solid #f0f0f0",
//   },
//   chatHint: {
//     fontSize: "11px",
//     color: "#999",
//     textAlign: "center",
//     display: "block",
//   },
// };

// // Add animation
// const styleSheet = document.styleSheets[0];
// styleSheet.insertRule(`
//   @keyframes fadeInUp {
//     from {
//       opacity: 0;
//       transform: translateY(20px);
//     }
//     to {
//       opacity: 1;
//       transform: translateY(0);
//     }
//   }
// `, styleSheet.cssRules.length);

// export default FooterMaamaas;



import React, { useState, useRef, useEffect } from "react";
import appstore from "./Cloudimages/appstore.png";
import playstore from "./Cloudimages/google.png";
import "./Fottermaamaas.css";



const FooterMaamaas = () => {
  const [openChat, setOpenChat] = useState(false);
  const [chatInput, setChatInput] = useState("");
  const [messages, setMessages] = useState([
    {
      text: "Hello! 👋 How can we help you today?",
      sender: "bot",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    }
  ]);
  const chatEndRef = useRef(null);

  const sendMessage = () => {
    if (!chatInput.trim()) return;

    const newMessage = {
      text: chatInput,
      sender: "user",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    setMessages((prev) => [...prev, newMessage]);
    setChatInput("");

    setTimeout(() => {
      const replies = [
        "Thank you for contacting Maamaas! Our support team will get back to you shortly 😊",
        "We've received your message. One of our representatives will assist you soon.",
        "Thanks for reaching out! We typically respond within 1-2 business hours.",
        "Your inquiry is important to us. We'll connect you with the right team member."
      ];
      const reply = {
        text: replies[Math.floor(Math.random() * replies.length)],
        sender: "bot",
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
      setMessages((prev) => [...prev, reply]);
    }, 800);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && chatInput.trim()) {
      sendMessage();
    }
  };

  return (
    <footer className="footer-maamaas">
      {/* Top Divider */}
      <div className="footer-divider" />

      {/* App Download Section */}
      {/* <div className="footer-container">
        <h2 className="footer-title">
          For the best experience, download the Maamaas app now
        </h2>

        <div className="store-container">
          <div 
            className="store-button"
            onClick={() => window.open("https://www.apple.com/in/app-store/", "_blank")}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && window.open("https://www.apple.com/in/app-store/", "_blank")}
          >
            <img
              src={appstore}
              alt="Download on App Store"
              className="store-image"
            />
            <div className="store-text-content">
              <div className="store-subtext">Download on the</div>
              <div className="store-maintext">App Store</div>
            </div>
          </div>
          
          <div 
            className="store-button"
            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.maamaas.app", "_blank")}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && window.open("https://play.google.com/store/apps/details?id=com.maamaas.app", "_blank")}
          >
            <img
              src={playstore}
              alt="Get it on Google Play"
              className="store-image"
            />
            <div className="store-text-content">
              <div className="store-subtext">Get it on</div>
              <div className="store-maintext">Google Play</div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Copyright */}
      <p className="footer-copyright">
        © 2025 Maamaas •@maamaas.com • All Rights Reserved by Envision Integrated Services Pvt. Ltd.
      </p>
      

      {/* Chat Button */}
{/* <button
  className={`chat-toggle-btn ${openChat ? 'chat-open' : ''}`}
  onClick={() => setOpenChat(!openChat)}
  aria-label={openChat ? "Close chat" : "Open chat"}
>
  <span className="chat-btn-text">
    {openChat ? "Close Chat" : "Let's Connect"}
  </span>
  <span className="chat-btn-icon">{openChat ? "✕" : "💬"}</span>
</button>

<button
  className="scroll-to-top-btn"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  aria-label="Scroll to top"
>
  ↑
</button> */}



      {/* Chat Box */}
      {openChat && (
        <div className="chat-widget">
          <div className="chat-header">
            <div className="chat-header-info">
              <div className="chat-avatar">M</div>
              <div>
                <div className="chat-title">Maamaas Support</div>
                <div className="chat-status">
                  <span className="status-indicator"></span>
                  Online • Usually replies in 5 mins
                </div>
              </div>
            </div>
            <div className="chat-header-actions">
              {/* <button className="chat-action-btn" aria-label="More options">⋯</button> */}
              <button 
                className="chat-action-btn"
                onClick={() => setOpenChat(false)}
                aria-label="Close chat"
              >✕</button>
            </div>
          </div>

          {/* Chat Messages Area */}
          <div className="chat-messages">
            <div className="chat-welcome">
              Welcome to Maamaas Support! How can we assist you today?
            </div>
            
            {messages.map((msg, index) => (
              <div
                key={`message-${index}`}
                className={`message-wrapper ${msg.sender === "user" ? "message-user" : "message-bot"}`}
              >
                {msg.sender === "bot" && (
                  <div className="message-avatar">M</div>
                )}
                <div
                  className={`message-bubble ${msg.sender === "user" ? "message-user-bubble" : "message-bot-bubble"}`}
                >
                  <div className="message-content">{msg.text}</div>
                  <div className="message-timestamp">
                    {msg.time} {msg.sender === "user" && "✓✓"}
                  </div>
                </div>
              </div>
            ))}
            <div ref={chatEndRef} className="chat-scroll-anchor" />
          </div>

          {/* Chat Input */}
          <div className="chat-input-area">
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Type your message here..."
                className="chat-input-field"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                aria-label="Type your message"
              />
              <div className="input-actions">
                <button className="attach-btn" aria-label="Attach file">📎</button>
                <button 
                  className={`send-btn ${chatInput.trim() ? 'send-active' : ''}`}
                  onClick={sendMessage}
                  disabled={!chatInput.trim()}
                  aria-label="Send message"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </div>
            </div>
            <div className="chat-footer">
              <span className="chat-hint">
                Press Enter to send • Support available 9 AM - 6 PM
              </span>
            </div>
          </div>
          
        </div>
        
      )}
      {/* Scroll to Top Button */}
{/* <button
  className="scroll-to-top-btn"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  aria-label="Scroll to top"
>
  ↑
</button> */}


    </footer>
  );

};

export default FooterMaamaas;
